import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { FiltersBar } from '../../components/filters-bar';
import { TopBar } from '../../components/top-bar';
import { OfferProItem } from '../../components/offer-pro-item';
import { useStore } from 'effector-react';
import {
  $tradeOffers,
  $tradeOffersLoadingState,
  fetchTradeOffersFx,
  setTradeOffers,
} from '../../store/business-offers.store';
import { useEffect, useState } from 'react';
import { OfferSidebar } from '../../components/sidebar';
import {
  deleteOffer,
  deleteSelectedOffers,
} from '../../functions/delete-offer.function';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import {
  $localSort,
  $selectedOffers,
  setSelectedOffers,
} from '../../store/offer-page.store';
import { debounce } from 'lodash-es';
import { createSortObjectForPreOffersPage } from '../../functions/create-sort-object.function';
import { Modal } from 'antd';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import classNames from 'classnames';
import { ButtonMain } from '@/modules/common/components/button';
import { PlaceholderEmpty } from '@/modules/common/components/placeholder-empty';
import { useNavigate } from 'react-router-dom';

export const OfferAdvancedPage = () => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const sortState = useStore($localSort);
  const tradeOffers = useStore($tradeOffers);
  const tradeOffersLoading = useStore($tradeOffersLoadingState);
  const selectedOffers = useStore($selectedOffers);
  const { width } = useWindowDimensions();
  const navigate = useNavigate();


  useEffect(() => {
    setTradeOffers([]);
    setSelectedOffers([]);
    const sortObj = createSortObjectForPreOffersPage(sortState);
    fetchTradeOffersFx(sortObj);
  }, []);

  useEffect(() => {
    const fetchWithDebounce = debounce(() => {
      const sortObj = createSortObjectForPreOffersPage(sortState);
      fetchTradeOffersFx(sortObj);
    }, 1000);

    fetchWithDebounce();

    return () => {
      fetchWithDebounce.cancel();
    };
  }, [sortState]);

  return (
    <PageTemplate className={styles.rootPage} mainClassName={styles.mainGlobal}>
      <div className={styles.root}>
        <div
          className={classNames(
            styles.main,
            width <= 1380 && sidebarActive && styles.hidden,
          )}
        >
          <div className={styles.mainTop}>
            <TopBar
              totalCount={tradeOffers?.length || 0}
              selectedCount={selectedOffers.length}
              deleteSelected={() =>
                selectedOffers.length > 0 &&
                Modal.confirm({
                  title: 'Подтвердите действие',
                  content: 'Вы действительно хотите удалить выбранные сделки?',
                  onOk: async () =>
                    await deleteSelectedOffers(
                      sortState,
                      selectedOffers,
                      setSelectedOffers,
                    ),
                  okText: 'да',
                  okButtonProps: { danger: true },
                  cancelText: 'нет',
                })
              }
              selectAll={() =>
                tradeOffers?.length === selectedOffers.length
                  ? setSelectedOffers([])
                  : setSelectedOffers(tradeOffers.map((item) => item.id))
              }
            />
            <FiltersBar />
          </div>
          <div className={styles.scrollableOffersArea}>
            {tradeOffersLoading.loading ? (
              <UniversalLoader />
            ) : tradeOffers && tradeOffers.length > 0 ? (
              tradeOffers.map((item) => (
                <OfferProItem
                  checked={selectedOffers.includes(item.id)}
                  onChange={() =>
                    selectedOffers.includes(item.id)
                      ? setSelectedOffers(
                          selectedOffers.filter((subItem) => subItem !== item.id),
                        )
                      : setSelectedOffers([...selectedOffers, item.id])
                  }
                  deleteFoo={async () => {
                    const sortObj = createSortObjectForPreOffersPage(sortState);
                    await deleteOffer(item.id, async () => {
                      await fetchTradeOffersFx(sortObj);
                      setSelectedOffers(
                        selectedOffers.filter((ofIdx) => ofIdx !== item.id),
                      );
                    });
                  }}
                  data={{ ...item, expiration_date: `${item.expiration_date} UTC`}}
                />
              ))
            ) : (
              <PlaceholderEmpty
                title="Вы пока не заключили ни одной сделки"
                label="Для продажи имеющегося на складах зерна, Вы можете воспользоваться интеллектуальным миксованием пшеницы"
                action={{ text: 'продать зерно', action: () => navigate('/mixing/recipes-new') }}
              />
            )}
          </div>
        </div>
        <div
          className={classNames(
            styles.sidebar,
            width <= 1380 && !sidebarActive && styles.hidden,
          )}
        >
          <OfferSidebar />
        </div>
        <ButtonMain
          className={styles.mobileSubmit}
          active={selectedOffers.length > 0}
          label={sidebarActive ? 'вернуться к списку' : 'оформить выбранные'}
          onClick={() => setSidebarActive(!sidebarActive)}
        />
      </div>
    </PageTemplate>
  );
};
